// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3op1Q","rootCenter":"LoadMoreObserver_rootCenter__QKs4V","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__17SzH"};